import { LandingTranslations } from '../../../types';

export const LANDING: LandingTranslations = {
  formLabelPersonalData: 'Datos Personales',
  formLabelAddressData: 'Dirección del Siniestro',
  formSubmitButton: 'Continuar con la conversación',
  formHeaderMainDesktop: 'Necesitamos algunos datos',
  formHeaderSub: 'Introduzca los siguientes datos para poder atenderle de forma segura y personalizada. Una vez haya finalizado, volverá a la conversación en WhatsApp.',
  formHeaderMainMobile: 'Accede con tus datos',
  loader: {
    1: 'Estamos',
    2: '  procesando sus datos',
    3: '. Por favor, espere un momento...',
  },
  errorComponentButton: 'Volver a Whatsapp',
  errorComponentMessage: {
    1: 'La sesión ha caducado.',
    2: ' Por favor, regrese a la',
    3: ' conversación de Whatsapp ',
    4: 'para introducir sus datos de nuevo.',
  },
  formTranslatedValue: {
    nif: {
      label: 'NIF o NIE',
      placeholder: '01234567A',
    },
    userName: {
      label: 'Nombre y Apellidos',
      placeholder: 'P. ej. Francisco Javier García Montero',
    },
    address: {
      label: 'Vía y número',
      placeholder: 'P. ej. Calle María Auxiliadora, número 15',
    },
    town: {
      label: 'Localidad',
      placeholder: 'P. ej. Castilleja de la Cuesta',
    },
    birthDate: {
      label: 'Fecha de nacimiento',
      placeholder: 'DD/MM/AAAA',
    },
  },
  alert: {
    404: 'No hemos conseguido identificarle, revise los datos e inténtelo de nuevo. Si lo prefiere puede contactar con nosotros llamando al: ',
    403: 'Para gestionar este siniestro ponte en contacto con nosotros llamando al: ',
    500: 'En este momento el servicio no está disponible. Inténtelo de nuevo o llámenos al: ',
    secondaryText404: 'O puede acceder a su ',
    secondaryText500: 'Si lo prefiere puede acceder a su ',
    privateArea: 'Área Privada',
    secondaryTextGeneric: ' introduciendo sus datos a traves del siguiente enlace ',
  },
};
